import { Col, Row } from 'reactstrap';
import { clx } from 'Utils';
import { Card } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';

// Skeleton style
const skeletonStyle: React.CSSProperties = {
	minHeight: 20,
	minWidth: 80
};

export const SkeletonSubscriptionPlan: FC = () => {
	return (
		<Col>
			<Card>
				<h6 className={clx(styles.row, 'text-gray-3 fs-6 fw-400')}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span className="fs-6">
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={clx(styles.rowLabel, 'fw-500')}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span className="fw-500">
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
